import Joyride, { type CallBackProps } from "react-joyride";
import { joyrideLocale, joyrideStyles } from "./joyrideConfig";
import { leaveRequestDetailTourSteps } from "./leaveRequestDetailTourSteps";
import { useLeaveTour } from "./useLeaveTour";

const TOUR_STORAGE_KEY = "hr-leave-request-detail-tour-completed";

type LeaveRequestDetailTourProps = {
  run: boolean;
  onCallback: (data: {
    status?: string;
    type?: string;
    index?: number;
  }) => void;
};

export function LeaveRequestDetailTour({
  run,
  onCallback,
}: LeaveRequestDetailTourProps) {
  const handleCallback = (data: CallBackProps) => {
    onCallback({ status: data.status, type: data.type, index: data.index });
  };

  return (
    <Joyride
      steps={leaveRequestDetailTourSteps}
      run={run}
      continuous
      showProgress
      showSkipButton
      callback={handleCallback}
      locale={joyrideLocale}
      styles={joyrideStyles}
      scrollToFirstStep
      scrollOffset={24}
      scrollDuration={300}
    />
  );
}

export function useLeaveRequestDetailTour() {
  return useLeaveTour(TOUR_STORAGE_KEY);
}
